



















  import { Component, Prop, Vue } from 'vue-property-decorator';
  import Header from '@/components/Header.vue';
  import PersonalProfile from '@/components/PersonalProfile.vue';
  import Skills from '@/components/Skills.vue';
  import Contact from '@/components/Contact.vue';
  import WorkExperience from '@/components/WorkExperience.vue';
  import Education from '@/components/Education.vue';

@Component({
  components: {
    Header, PersonalProfile, Skills, Contact, WorkExperience, Education
  },
})
export default class Resume extends Vue {
}
